import {sortChat} from '../util/chatUtils';
import * as chatUtils from '../util/chatUtils';

const initialState={
  coaches       : null,
  chatrooms     : null,
  chatroomId    : null,
  chatLog       : null,
  last_chat     : null,
  pushVisible   : false,
  is_first      : null,               // for description part
};

function coachReducer(state=initialState, action){
  switch (action.type){
    case "GET_COACHES_FULFILLED":{
      return Object.assign({}, state, {
        coaches: action.payload
      });
    }

    case "GET_CHATS_FULFILLED":{
      let log = [];
      let last_chat = {date:null, is_admin:null};
      if(action.payload.messages.length>0){
        let sortedData = sortChat(action.payload.messages);
        log = sortedData.log;
        last_chat = sortedData.last_chat;
      }

      return Object.assign({}, state, {
        chatLog: log,
        last_chat: last_chat,
        pushVisible: false
      });
    }

    case "GET_CHATROOMS_FULFILLED":{
      let pushVisible = false;
      let coach_name = null;
      let is_first = true;
      if(action.payload.length>0){
        is_first = false;
        coach_name = action.payload[0].coach.name;
        if(action.payload[0].unread>0){
          pushVisible = true;
        }
      }
      return Object.assign({}, state, {
        chatrooms: action.payload,
        chatroomId: action.payload.length>0?action.payload[0].id:null,
        pushVisible: pushVisible,
        coachName: coach_name,
        is_first: is_first
      });
    }

    case "POST_CHATROOMS_FULFILLED":{
      return Object.assign({}, state, {
        chatrooms: [action.payload],
        chatLog: [],
        chatroomId: action.payload.chatroom_id,
        is_first: false
      });
    }

    /*
      case 1: Chat log empty

      case 2: Chat on the same date as the last chat

      case 3: Chat on the different date as the last chat

      inner case of case2 and case3
          last author same as new chat author
          last author different as new chat author
    */
    case "NEW_MESSAGE_ARRIVED":{
      let {last_chat, chatLog, last_date, curr_date} = chatUtils.getObjects(state.last_chat, state.chatLog);
      let newMessage = action.payload
      let isAdmin = newMessage.coach_id?true:false;

      if(chatLog.length===0 || last_date !== curr_date.toDateString()){
        let newChat = chatUtils.getChatArray(newMessage, curr_date, isAdmin);
        chatLog.push(newChat);
      } else if (last_date === curr_date.toDateString()){
        if(last_chat.is_admin !== isAdmin){
          let newChat = chatUtils.getChats(newMessage, isAdmin);
          chatLog[chatLog.length-1].chatArray.push(newChat);
        }else{
          let chatArray = chatLog[chatLog.length-1].chatArray;
          chatArray[chatArray.length-1].chats.push(newMessage);
        }
      }

      return Object.assign({}, state, {
        chatLog: chatLog,
        last_chat: {date: curr_date, is_admin: isAdmin}
      });
    }

    case "NEW_ALARM_ARRIVED":{
      return Object.assign({}, state, {
        pushVisible : true
      })
    }

    default:
      return state;
  }
}

export default coachReducer;



// WEBPACK FOOTER //
// ./src/reducers/CoachReducer.js